import React from 'react';
import { useNavigate } from 'react-router-dom';

/* Handoff verso l'Export: riepiloga la selezione di aree e la passa al Compositore.
   Il salvataggio delle aree avviene dal widget "Aree salvate" nell'header della dashboard. */
export default function ExportPanel({ selectedRegions, selectedProvinces, provRows, onClear }) {
  const navigate = useNavigate();

  const covered = provRows.filter(r => selectedRegions.has(r.regione) || selectedProvinces.has(r.nome));
  const pronti = covered.reduce((s, r) => s + (r.esportabili || 0), 0);
  const totNumeri = covered.reduce((s, r) => s + (r.tot || 0), 0);
  const nSel = selectedRegions.size + selectedProvinces.size;

  const manda = () => {
    if (nSel === 0) return;
    navigate('/export', { state: { exportSel: { regioni: [...selectedRegions], province: [...selectedProvinces] } } });
  };

  return (
    <div className="evo-card xp-card">
      <div className="evo-card-head">
        <span>Esportazione</span>
        {nSel > 0 && <button className="evo-btn-sm" style={{ background: 'var(--accent-dark, #b5480a)' }} onClick={onClear}>Pulisci</button>}
      </div>

      <div className="xp-summary">
        <div className="xp-sum-item"><span className="v">{selectedRegions.size}</span><span className="l">regioni</span></div>
        <div className="xp-sum-item"><span className="v">{selectedProvinces.size}</span><span className="l">province</span></div>
        <div className="xp-sum-item"><span className="v">{totNumeri.toLocaleString('it-IT')}</span><span className="l">numeri</span></div>
        <div className="xp-sum-item xp-hl"><span className="v">{pronti.toLocaleString('it-IT')}</span><span className="l">pronti export</span></div>
      </div>

      <div style={{ marginTop: 'auto', paddingTop: 14 }}>
        <button className="btn btn-primary" style={{ width: '100%' }} disabled={nSel === 0} onClick={manda}>
          Manda all'Export
        </button>
        <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 8, textAlign: 'center' }}>
          Seleziona le aree qui, poi mandale al Compositore (filtri, quantità, download).
          Per riusarle, salvale come "Aree salvate" dall'header della dashboard.
        </div>
      </div>
    </div>
  );
}
